import React, { useEffect, useState } from "react";
import { Card, Row, Col, Table, Badge } from "react-bootstrap";
import API from "../../api/api";

export default function DistributorEarningsDashboard() {
  const [totals, setTotals] = useState(null);
  const [earnings, setEarnings] = useState([]);

  useEffect(() => {
    const fetchEarnings = async () => {
      try {
        const res = await API.get(`/api/earnings/get-dis-earnings`, {
          withCredentials: true,
        });
        if (res.data.success) {
          setTotals(res.data.totals);
          setEarnings(res.data.earnings);
        }
      } catch (err) {
        console.error("Error fetching earnings:", err);
      }
    };
    fetchEarnings();
  }, []);

  if (!totals) return <p className="text-center mt-5">Loading earnings...</p>;

  return (
    <div className="container mt-4">
      <h3 className="mb-4">My Earnings</h3>

      {/* Summary Cards */}
      <Row className="mb-4">
        <Col md={4}>
          <Card className="shadow-sm text-center p-3">
            <h5>Approved Earnings</h5>
            <h3 className="text-success">Rs. {totals.approved}</h3>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="shadow-sm text-center p-3">
            <h5>Pending Earnings</h5>
            <h3 className="text-warning">Rs. {totals.pending}</h3>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="shadow-sm text-center p-3">
            <h5>Rejected Earnings</h5>
            <h3 className="text-danger">Rs. {totals.rejected}</h3>
          </Card>
        </Col>
      </Row>

      {/* Breakdown */}
      <Row className="mb-4">
        <Col md={12}>
          <Card className="shadow-sm p-3">
            <h6 className="mb-2">Product Earnings</h6>
            <p>
              Approved: <strong>Rs. {totals.product.approved}</strong>
            </p>
            <p>
              Pending: <strong>Rs. {totals.product.pending}</strong>
            </p>
            <p>
              Rejected: <strong>Rs. {totals.product.rejected}</strong>
            </p>
          </Card>
        </Col>
        {/* <Col md={6}>
          <Card className="shadow-sm p-3">
            <h6 className="mb-2">Referral Earnings</h6>
            <p>
              Approved: <strong>Rs. {totals.referral.approved}</strong>
            </p>
            <p>
              Pending: <strong>Rs. {totals.referral.pending}</strong>
            </p>
            <p>
              Rejected: <strong>Rs. {totals.referral.rejected}</strong>
            </p>
          </Card>
        </Col> */}
      </Row>

      {/* Earnings Table */}
      <Card className="shadow-sm">
        <Card.Header>Earnings Details</Card.Header>
        <Card.Body>
          <Table responsive bordered hover>
            <thead className="table-light">
              <tr className="text-center">
                <th>#</th>
                <th>Type</th>
                <th>Linked To</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {earnings.map((e, i) => (
                <tr key={e._id} className="text-center">
                  <td>{i + 1}</td>
                  <td>
                    <Badge
                      bg={e.earningType === "Product" ? "info" : "success"}
                    >
                      {e.earningType}
                    </Badge>
                  </td>
                  <td>
                    {e.earningType === "Product" && e.order ? (
                      <>Order #{e.order.orderNumber}</>
                    ) : (
                      <>
                        {e.referredUser
                          ? `${e.referredUser.first_name} ${e.referredUser.last_name}`
                          : "-"}
                      </>
                    )}
                  </td>
                  <td>Rs. {e.amount}</td>
                  <td>
                    <Badge
                      bg={
                        e.status === "Approved"
                          ? "success"
                          : e.status === "Pending"
                          ? "warning"
                          : "danger"
                      }
                    >
                      {e.status}
                    </Badge>
                  </td>
                  <td>{new Date(e.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </div>
  );
}












// import React, { useEffect, useState } from "react";
// import { Card, Row, Col, Table, Badge } from "react-bootstrap";
// import API from "../../api/api";

// export default function DistributorEarningsDashboard() {
//   const [totals, setTotals] = useState(null);
//   const [earnings, setEarnings] = useState([]);

//   useEffect(() => {
//     const fetchEarnings = async () => {
//       try {
//         const res = await API.get(`/api/earnings/get-dis-earnings`, {
//           withCredentials: true,
//         });
//         if (res.data.success) {
//           setTotals(res.data.totals);
//           setEarnings(res.data.earnings);
//         }
//       } catch (err) {
//         console.error("Error fetching earnings:", err);
//       }
//     };
//     fetchEarnings();
//   }, []);

//   if (!totals) return <p className="text-center mt-5">Loading earnings...</p>;

//   return (
//     <div className="container mt-4">
//       <h3 className="mb-4">My Earnings</h3>

//       {/* Summary Cards */}
//       <Row className="mb-4">
//         <Col md={4}>
//           <Card className="shadow-sm text-center p-3">
//             <h5>Active Earnings</h5>
//             <h3 className="text-success">Rs. {totals.active}</h3>
//           </Card>
//         </Col>
//         <Col md={4}>
//           <Card className="shadow-sm text-center p-3">
//             <h5>Processing</h5>
//             <h3 className="text-warning">Rs. {totals.processing}</h3>
//           </Card>
//         </Col>
//         <Col md={4}>
//           <Card className="shadow-sm text-center p-3">
//             <h5>Paid Out</h5>
//             <h3 className="text-primary">Rs. {totals.paid}</h3>
//           </Card>
//         </Col>
//       </Row>

//       {/* Breakdown */}
//       <Row className="mb-4">
//         <Col md={6}>
//           <Card className="shadow-sm p-3">
//             <h6 className="mb-2">Product Earnings</h6>
//             <p>
//               Active: <strong>Rs. {totals.product.active}</strong>
//             </p>
//             <p>
//               Processing: <strong>Rs. {totals.product.processing}</strong>
//             </p>
//             <p>
//               Paid: <strong>Rs. {totals.product.paid}</strong>
//             </p>
//           </Card>
//         </Col>
//         <Col md={6}>
//           <Card className="shadow-sm p-3">
//             <h6 className="mb-2">Referral Earnings</h6>
//             <p>
//               Active: <strong>Rs. {totals.referral.active}</strong>
//             </p>
//             <p>
//               Processing: <strong>Rs. {totals.referral.processing}</strong>
//             </p>
//             <p>
//               Paid: <strong>Rs. {totals.referral.paid}</strong>
//             </p>
//           </Card>
//         </Col>
//       </Row>

//       {/* Earnings Table */}
//       <Card className="shadow-sm">
//         <Card.Header>Earnings Details</Card.Header>
//         <Card.Body>
//           <Table responsive bordered hover>
//             <thead className="table-light">
//               <tr className="text-center">
//                 <th>#</th>
//                 <th>Type</th>
//                 <th>Linked To</th>
//                 <th>Amount</th>
//                 <th>Status</th>
//                 <th>Date</th>
//               </tr>
//             </thead>
//             <tbody>
//               {earnings.map((e, i) => (
//                 <tr key={e._id} className="text-center">
//                   <td>{i + 1}</td>
//                   <td>
//                     <Badge
//                       bg={e.earningType === "Product" ? "info" : "success"}
//                     >
//                       {e.earningType}
//                     </Badge>
//                   </td>
//                   <td>
//                     {e.earningType === "Product" && e.order ? (
//                       <>Order #{e.order.orderNumber}</>
//                     ) : (
//                       <>
//                         {e.referredUser
//                           ? `${e.referredUser.first_name} ${e.referredUser.last_name}`
//                           : "-"}
//                       </>
//                     )}
//                   </td>
//                   <td>Rs. {e.amount}</td>
//                   <td>
//                     <Badge
//                       bg={
//                         e.status === "Approved"
//                           ? "success"
//                           : e.status === "Pending"
//                           ? "warning"
//                           : "danger"
//                       }
//                     >
//                       {e.status}
//                     </Badge>
//                   </td>

//                   <td>{new Date(e.createdAt).toLocaleDateString()}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//         </Card.Body>
//       </Card>
//     </div>
//   );
// }
